import {createDefaultTheme} from "./themeConfigurator";

export default createDefaultTheme();
